import React from "react"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../../../../../../hooks/enterprise"
import LayoutMain from "../../../../../../../components/Layouts/LayoutMain"
import { useShopGetOne, useShopId } from "../../../../../../../hooks/shop"
import LayoutLoadingAuthRequired from "../../../../../../../components/Layouts/LayoutLoadingAuthRequired"
import NavSaleHeader from "../../../../../../../components/Navs/NavSaleHeader"
import NavSaleSearch from "../../../../../../../components/Navs/NavSaleSearch"
import { useRouter } from "next/router"
import queryString from "query-string"
import ItemList from "../../../../../../../components/Item/ItemList"
import CheckoutItemList from "../../../../../../../components/Checkout/CheckoutItemList"
import CheckoutSummary from "../../../../../../../components/Checkout/CheckoutSummary"
import CheckoutNextButton from "../../../../../../../components/Checkout/CheckoutNextButton"
import { useAtom as GetAtom } from "jotai"
import { checkoutStepAtom } from "../../../../../../../store/checkout"
import CheckoutPaymentMethod from "../../../../../../../components/Checkout/CheckoutPaymentMethod"
import { useShopSalePointId } from "../../../../../../../hooks/shopSalePoint"
import CheckoutFinishSuccess from "../../../../../../../components/Checkout/CheckoutFinishSuccess"

const Title = "Новая продажа"

// const CancelToken = axios.CancelToken;
// const sourceSearchItems = CancelToken.source();

function Main() {
  const router = useRouter()
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()

  const [checkoutStep] = GetAtom(checkoutStepAtom)

  const { isLoading: isLoadingEnterprise, isError: isErrorEnterprise } =
    useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )

  if (
    isLoadingEnterprise ||
    isLoadingShop ||
    isErrorEnterprise ||
    isErrorShop
  ) {
    return (
      <React.Fragment>
        <LayoutLoadingAuthRequired
          isLoading={isLoadingEnterprise || isLoadingShop}
          isError={isErrorEnterprise || isErrorShop}
        />
      </React.Fragment>
    )
  }

  const onSearchChange = async (value: string) => {
    await searchItems(value)
  }

  const searchItems = async (value?: string) => {
    const query = { searchText: value || null }
    const queryStr = queryString.stringify(query, { skipNull: true })

    await router.push(
      `/e/${enterpriseId}/s/${shopId}/${shopSalePointId}/sales?${queryStr}`
    )
  }

  const MainContent = () => {
    switch (checkoutStep) {
      case "0":
        return <ItemList />
      case "1":
        return <CheckoutPaymentMethod />
      case "2":
        return <CheckoutFinishSuccess />
      default:
        return null
    }
  }

  return (
    <React.Fragment>
      <LayoutMain title={Title}>
        {/* Nav */}
        <NavSaleHeader className="bg-indigo-600 pb-40 lg:pb-24" />

        {/* Nav main navigation */}
        <div className="border-opacity-20 -mt-40 border-t border-white py-5 pb-8 lg:-mt-24">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <NavSaleSearch onSearchChange={onSearchChange} />
          </div>
        </div>

        <main className="pb-8">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <h1 className="sr-only">{Title}</h1>
            {/* Main 3 column grid */}
            <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-3 lg:gap-8">
              {/* Left column */}
              <div className="grid grid-cols-1 gap-4 lg:col-span-2">
                <section aria-labelledby="section-1-title">
                  <div className="overflow-hidden rounded-lg bg-white shadow">
                    <MainContent />
                  </div>
                </section>
              </div>

              {/* Right column */}
              <div className="grid grid-cols-1 gap-4">
                <div className="rounded-lg bg-white shadow">
                  <section aria-labelledby="section-2-title">
                    <div className="overflow-hidden rounded-lg bg-white shadow-md">
                      <CheckoutItemList />
                    </div>

                    <CheckoutSummary />

                    <CheckoutNextButton />
                  </section>
                </div>
              </div>
            </div>
          </div>
        </main>
      </LayoutMain>
    </React.Fragment>
  )
}

export default Main
